var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_744",
    "data-name": "\\u7EC4 744",
    transform: "translate(-1752.034 -1046.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_743",
    "data-name": "\\u7EC4 743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_340",
    "data-name": "\\u8DEF\\u5F84 340",
    d: "M1764.222,1046.93h1.625a1.484,1.484,0,0,0,.195.042,12.374,12.374,0,0,1,5.646,1.795,12.832,12.832,0,0,1,6.147,8.923c.088.472.134.951.2,1.428v1.625c-.021.166-.044.333-.062.5a13.034,13.034,0,0,1-10.674,11.487c-.48.087-.967.135-1.451.2h-1.625c-.317-.039-.636-.073-.952-.118a13.028,13.028,0,0,1-11.034-10.617c-.087-.48-.135-.968-.2-1.452v-1.625c.021-.167.043-.333.062-.5a13.027,13.027,0,0,1,10.724-11.492C1763.285,1047.045,1763.754,1046.995,1764.222,1046.93Zm.836,5.5v.09c-1.074,0-2.149-.02-3.223.006a4.452,4.452,0,0,0-2.426.715,4.013,4.013,0,0,0-1.774,3.445c-.043,2.165-.027,4.332,0,6.5a4.272,4.272,0,0,0,.711,2.374,4.015,4.015,0,0,0,3.446,1.775c2.165.044,4.331.038,6.5,0a4.1,4.1,0,0,0,3.085-1.321,4.28,4.28,0,0,0,1.071-2.886c.04-1.776.043-3.553.045-5.33a15.509,15.509,0,0,0-.09-1.57,3.922,3.922,0,0,0-3.662-3.649C1767.513,1052.473,1766.284,1052.473,1765.058,1052.427Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_341",
    "data-name": "\\u8DEF\\u5F84 341",
    d: "M1765.035,1066.073c-1.125-.032-2.251-.035-3.373-.1a2.6,2.6,0,0,1-2.66-2.671c-.061-2.265-.043-4.533,0-6.8a2.5,2.5,0,0,1,1.378-2.276,3.481,3.481,0,0,1,1.643-.37c2.131,0,4.264-.025,6.393.043a2.563,2.563,0,0,1,2.647,2.65q.09,3.384,0,6.772a2.612,2.612,0,0,1-2.631,2.652c-.565.041-1.132.055-1.7.066s-1.134,0-1.7,0Zm3.83-6.149a3.831,3.831,0,1,0-3.838,3.836A3.824,3.824,0,0,0,1768.865,1059.924Zm1.047-3.978a.892.892,0,1,0-.907.89A.89.89,0,0,0,1769.912,1055.946Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_342",
    "data-name": "\\u8DEF\\u5F84 342",
    d: "M1765.031,1057.442a2.488,2.488,0,1,1-2.484,2.485A2.492,2.492,0,0,1,1765.031,1057.442Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFilled);
export default __webpack_public_path__ + "static/media/instagram_filled.6a43ef84373f1bdd2f72c5cb4c549ef2.svg";
export { ForwardRef as ReactComponent };